/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import gql from "graphql-tag";
import { listVendors, getCustomerTeam } from "../../graphql/queries";
import { spinnerService } from "@chevtek/react-spinners";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { mainDashboardQuery } from "../../data/customQueries";
import moment from "moment";
import { createCustomerVendor } from "../../graphql/mutations";
import { Typography } from "@material-ui/core";

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const Vendors = ({ client, user }) => {
  const [vendorsList, setVendorsList] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [customerInfo, setCustomerInfo] = useState({});
  const selectVendor = async id => {
    spinnerService.show("mySpinner");
    try {
      const info = await client.mutate({
        mutation: gql(createCustomerVendor),
        variables: {
          input: {
            vendorID: id,
            customerID: customerInfo.id,
            offerStatus: "ACCEPTED"
          }
        }
      });
      await fetchData();
      spinnerService.hide("mySpinner");
    } catch (err) {
      spinnerService.hide("mySpinner");
      return;
    }
  };
  const getCustomer = async () => {
    let dueDate = moment(new Date()).add(14, "days");
    let temp = [];
    let custUsername = user.username;
    let userType = null;
    if (
      user !== null &&
      user !== "notFound" &&
      user.signInUserSession.idToken.payload["cognito:groups"] !== undefined
    ) {
      userType = user.signInUserSession.idToken.payload["cognito:groups"][0];
    }
    if ((userType === "Dispatchers") | (userType === "Technicians")) {
      let custTeam = (await client.query({
        query: gql(getCustomerTeam),
        fetchPolicy: `network-only`,
        variables: { id: user.username }
      })).data.getCustomerTeam;
      custUsername = custTeam.customer.id;
    }
    try {
      const cust = (await client.query({
        query: gql(mainDashboardQuery),
        fetchPolicy: `network-only`,
        variables: { id: custUsername, dueDate: dueDate }
      })).data.getCustomer;
      
      setCustomerInfo({ id: cust.id });
      if (cust.vendors && cust.vendors.items.length > 0) {
        cust.vendors.items.map(cv => {
          temp.push(cv.vendorID);
        });
        setSelectedVendors(temp);
      }
    } catch (err) {
      
      spinnerService.hide("mySpinner");
    }
  };
  const getVendors = async () => {
    try {
      const vendors = await client.query({
        query: gql(listVendors),
        fetchPolicy: `network-only`
      });
      
      setVendorsList(vendors.data.listVendors.items);
    } catch (err) {
      
      spinnerService.hide("mySpinner");
    }
  };
  const fetchData = async () => {
    spinnerService.show("mySpinner");
    await getCustomer();
    await getVendors();
    spinnerService.hide("mySpinner");
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      <Paper
        style={{
          width: "100%",
          marginTop: "3",
          overflowX: "auto"
        }}
      >
        <Table
          style={{
            minWidth: 700
          }}
        >
          <TableHead>
            <TableRow>
              <CustomTableCell>Id</CustomTableCell>
              <CustomTableCell align="right">Company</CustomTableCell>
              <CustomTableCell align="right">Email</CustomTableCell>
              <CustomTableCell align="right" />
            </TableRow>
          </TableHead>
          {vendorsList.length > 0 ? (
            <TableBody>
              {vendorsList.map(row => (
                <TableRow key={row.id}>
                  <CustomTableCell component="th" scope="row">
                    {row.id}
                  </CustomTableCell>
                  <CustomTableCell align="right">
                    {row.companyName}
                  </CustomTableCell>
                  <CustomTableCell align="right">{row.email}</CustomTableCell>
                  <CustomTableCell align="right">
                    {!selectedVendors.includes(row.id) ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => selectVendor(row.id)}
                      >
                        Select
                      </Button>
                    ) : (
                      <Typography>Selected</Typography>
                    )}
                  </CustomTableCell>
                </TableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <CustomTableCell colSpan={6}>
                  {" "}
                  <div
                    style={{
                      alignContent: "center",
                      justifyContent: "center",
                      marginLeft: "45%",
                      fontSize: 16
                    }}
                  >
                    {" "}
                    No Data{" "}
                  </div>{" "}
                </CustomTableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </Paper>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client
  };
};
export default connect(mapStateToProps)(Vendors);



// WEBPACK FOOTER //
// ./src/customers/Vendor/Vendors.js